import { Box, makeStyles, Popover, Typography } from '@material-ui/core';
import { CSSProperties, MouseEvent, useEffect, useState } from 'react';
import { WbTextField } from '../WbTextField';
import { FiltersButton } from './FilterButtons';
import { FilterInput } from './FilterInput';
import { StringTableFilter } from './types';
import { useFilterRegistration } from '../WbTable';

const useStyles = makeStyles(
  theme => ({
    paper: {
      [theme.breakpoints.down('xs')]: {
        width: '100vw !important',
        height: '100vh !important',
        left: '0 !important',
        top: '0 !important',
        maxWidth: '100vw !important',
        maxHeight: '100vh !important',
      },
    },
    root: {
      width: '280px',
      background: 'white',
      [theme.breakpoints.down('xs')]: {
        width: '100% !important',
        height: '100% !important',
        display: 'flex',
        flexDirection: 'column',
      },
    },
    inputContainer: {
      padding: theme.spacing(1),
      width: '100%',
      display: 'block',

      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(1.5),
        overflowY: 'auto',
        overflowX: 'auto',
        display: 'flex',
        flex: 1,
      },
    },
  }),
  { name: 'StringFilter' },
);

const StringFilterValue = ({ field, value }: StringTableFilter) => {
  const ellipsis: CSSProperties = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  // Register this filter's active state with the parent toolbar
  useFilterRegistration(value, field);

  return (
    <Typography style={ellipsis}>
      {field}
      {value && (
        <>
          <Typography component="span">:</Typography>
          <Typography
            style={{ fontWeight: '600', marginLeft: '5px' }}
            component="span"
          >
            {value}
          </Typography>
        </>
      )}
    </Typography>
  );
};

export const StringFilter = (filter: StringTableFilter) => {
  const [value, setValue] = useState(filter.value);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setTimeout(() => setValue(filter.value), 500);
    setAnchorEl(null);
  };

  useEffect(() => {
    setValue(filter.value);
  }, [filter.value]);

  return (
    <Box>
      <FilterInput
        onClick={handleClick}
        onClear={() => {
          filter.onChange(undefined);
          setValue(undefined);
        }}
        isOpened={open}
        selected={Boolean(filter.value)}
        hideClear={filter.hideClear}
      >
        <StringFilterValue {...filter} />
      </FilterInput>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        classes={{
          paper: classes.paper,
        }}
      >
        <Box className={classes.root}>
          <Box className={classes.inputContainer}>
            <WbTextField
              variant="outlined"
              placeholder={
                filter.placeholder
                  ? filter.placeholder
                  : 'Start typing to filter'
              }
              InputLabelProps={{ shrink: true }}
              onChange={e => setValue(String(e.target.value))}
              value={value}
              fullWidth
              label={filter.field}
            />
          </Box>

          <FiltersButton
            cancel={{
              onClick: handleClose,
            }}
            apply={{
              onClick: () => {
                filter.onChange(value);
                setAnchorEl(null);
              },
            }}
          />
        </Box>
      </Popover>
    </Box>
  );
};
